/** Calc type codes returned by the finance calc type endpoint. */
export const FINANCE_CALC_TYPES = {
    PERCENTAGE: "PERCENTAGE",
    PERCENTAGE_WITH_CAP: "PERCENTAGE_WITH_CAP",
    PERCENTAGE_WITH_FLOOR_AND_CAP: "PERCENTAGE_WITH_FLOOR_AND_CAP",
    FIXED_AMOUNT: "FIXED_AMOUNT",
} as const;

export type FinanceCalcType = (typeof FINANCE_CALC_TYPES)[keyof typeof FINANCE_CALC_TYPES];

/** Frontend-only choice meaning "this deductible is not configured"; never sent to the API. */
export const NO_ALLOCATION = "NO_ALLOCATION";

export const NO_ALLOCATION_LABEL = "No allocation";

export type DeductibleCalcChoice = FinanceCalcType | typeof NO_ALLOCATION;

export type DeductibleAmountField = "rate" | "floor_amount" | "cap_amount" | "fixed_amount";

/** Fields each calc type requires (and the only ones it accepts). */
export const CALC_TYPE_FIELDS: Record<FinanceCalcType, DeductibleAmountField[]> = {
    [FINANCE_CALC_TYPES.PERCENTAGE]: ["rate"],
    [FINANCE_CALC_TYPES.PERCENTAGE_WITH_CAP]: ["rate", "cap_amount"],
    [FINANCE_CALC_TYPES.PERCENTAGE_WITH_FLOOR_AND_CAP]: ["rate", "floor_amount", "cap_amount"],
    [FINANCE_CALC_TYPES.FIXED_AMOUNT]: ["fixed_amount"],
};

export const DEDUCTIBLE_FIELD_LABELS: Record<DeductibleAmountField, string> = {
    rate: "Rate (%)",
    floor_amount: "Floor",
    cap_amount: "Cap / Ceiling",
    fixed_amount: "Fixed Amount",
};

export const isFinanceCalcType = (value: string | null | undefined): value is FinanceCalcType =>
    !!value && Object.values(FINANCE_CALC_TYPES).includes(value as FinanceCalcType);

export const fieldsForCalcType = (calcType: string | null | undefined): DeductibleAmountField[] =>
    isFinanceCalcType(calcType) ? CALC_TYPE_FIELDS[calcType] : [];
